import axios from "axios";
import Constants from "../../../components.constants.js";


export default {
    async getRemoteSystemStatsClientsList(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.remoteSystemStatsClientListData, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getRemoteSystemStatsClientsList][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401){
                    return context.dispatch("users/logOutFromServer", {},{root:true})
                }
                else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
    async getRemoteSystemStats(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.remoteSystemStatsIndData+"/"+payload.product_id, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getRemoteSystemStats][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401){
                    return context.dispatch("users/logOutFromServer", {},{root:true})
                }
                else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getRemoteSystemStatsOfAllClients(context, payload = {}) {
        try {
            let url = `${Constants.allResourceusageByGroupUrl}`
            if(payload.client_name && payload.client_name.length > 0){
                url = `${Constants.allResourceusageByGroupUrl}?client_name=${payload.client_name}`
            }
            if(payload.product_name && payload.product_name.length > 0){
                url = `${Constants.allResourceusageByGroupUrl}?product_name=${payload.product_name}`
            }
            if(payload.product_name && payload.product_name.length > 0 && payload.client_name && payload.client_name.length > 0){
                url = `${Constants.allResourceusageByGroupUrl}?product_name=${payload.product_name}&client_name=${payload.client_name}`
            }
            let resp = await axios.get(url, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getRemoteSystemStatsOfAllClients][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401){
                    return context.dispatch("users/logOutFromServer", {},{root:true})
                }
                else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },



};
